//TODO Env based api const
export const API_URL = import.meta.env.VITE_API_URL;
export const IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_BASE_URL;
